module.exports = {"id":"215251","name":"Guido Herrera","rating":"71","photo":"./data/images/photos/0/215251.png","club":{"name":"CA Talleres","logo":"./data/images/clubs/CATalleres.png"},"positions":["G"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GuidoHerrera0.json
// module id = 1651
// module chunks = 0